import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-dialog-confirm',
    templateUrl: 'confirmation-dialog.html',
})
export class ConfirmationDialogComponent {
    message: string;
    confirmButtonText = 'Yes';
    cancelButtonText = 'Cancel';
    constructor(
        @Inject(MAT_DIALOG_DATA) private data: any,
        private dialogRef: MatDialogRef<ConfirmationDialogComponent>) {
        if (data) {
            this.message = data.message || '';
            if (data.buttonText) {
                this.confirmButtonText = data.buttonText.ok || this.confirmButtonText;
                this.cancelButtonText = data.buttonText.cancel || this.cancelButtonText;
            }
        }
        /**
         * this code use to close dialog by press 'esc'
         * TODO: if anyone find better solution can improve it for me
         */
        dialogRef.keydownEvents().subscribe(res => {
            if (res.keyCode === 27) {
                dialogRef.close();
            }
        });
    }

    cancel() {
        this.dialogRef.close();
    }

    onConfirmClick(): void {
        this.dialogRef.close(true);
    }

}
